import actions from "./actions";

const initState = {
    planWiseMappingList: [],
    planWiseMappingLoading: false,
    planWiseMappingError: null,
    planWiseMappingMessage: null,
    loading: false,
    buttonLoading: false,
    planPriceMappingError: null,
    planPriceMappingSuccess: null,
    PlanPriceMappingData: [],
    rechargeMappingLoading: false,
    rechargeMappingError: null,
    rechargeMappingMessage: null,
    rechargeMappingData: [],
    updateRechargeMappingLoading: false,
    updateRechargeMappingError: null,
    updateRechargeMappingMessage: null,
    checkRechargeMappingExistsLoading: false,
    checkRechargeMappingExistsError: null,
    checkRechargeMappingExistsMessage: null,
    planChildPriceMappingError: null,
    planChildPriceMappingSuccess: null,
    dailyPlanMappingLoading: false,
    dailyPlanMappingError: null,
    dailyPlanMappingMessage: null,
    dailyPlanMappingData: [],
    updateDailyPlanMappingLoading: false,
    updateDailyPlanMappingError: null,
    updateDailyPlanMappingMessage: null,
    portinMappingLoading: false,
    portinMappingError: null,
    portinMappingMessage: null,
    portinMappingData: [],
    updatePortinMappingLoading: false,
    updatePortinMappingError: null,
    updatePortinMappingMessage: null,

    openPortinModal: false,

    updatePortinMappingByDealerIDLoading: false,
    updatePortinMappingByDealerIDError: null,
    updatePortinMappingByDealerIDMessage: null,

    updateDailyPlanMappingByDealerIDLoading: false,
    updateDailyPlanMappingByDealerIDError: null,
    updateDailyPlanMappingByDealerIDMessage: null,

    updateRechargeMappingByDealerIDLoading: false,
    updateRechargeMappingByDealerIDError: null,
    updateRechargeMappingByDealerIDMessage: null,

    updatePlanPriceMappingByDealerIDLoading: false,
    updatePlanPriceMappingByDealerIDError: null,
    updatePlanPriceMappingByDealerIDMessage: null,

    updateChildPriceMappingByDealerIDLoading: false,
    updateChildPriceMappingByDealerIDError: null,
    updateChildPriceMappingByDealerIDMessage: null,
};

export default function reducer(state = initState, action) {
    switch (action.type) {

        case actions.UPDATE_CHILD_PRICE_MAPPING_BY_DEALERID:
            return {
                ...state,
                updateChildPriceMappingByDealerIDLoading: true,
                updateChildPriceMappingByDealerIDError: null,
                updateChildPriceMappingByDealerIDMessage: null,
            };
        case actions.UPDATE_CHILD_PRICE_MAPPING_BY_DEALERID_SUCCESS:
            return {
                ...state,
                updateChildPriceMappingByDealerIDLoading: false,
                updateChildPriceMappingByDealerIDError: null,
                updateChildPriceMappingByDealerIDMessage: action.payload.message,
                openPortinModal: false,
            };
        case actions.UPDATE_CHILD_PRICE_MAPPING_BY_DEALERID_FAILED:
            return {
                ...state,
                updateChildPriceMappingByDealerIDLoading: false,
                updateChildPriceMappingByDealerIDError: action.payload.error,
                updateChildPriceMappingByDealerIDMessage: null,
            };

        case actions.UPDATE_PLAN_PRICE_MAPPING_BY_DEALERID:
            return {
                ...state,
                updatePlanPriceMappingByDealerIDLoading: true,
                updatePlanPriceMappingByDealerIDError: null,
                updatePlanPriceMappingByDealerIDMessage: null,
            };
        case actions.UPDATE_PLAN_PRICE_MAPPING_BY_DEALERID_SUCCESS:
            return {
                ...state,
                updatePlanPriceMappingByDealerIDLoading: false,
                updatePlanPriceMappingByDealerIDError: null,
                updatePlanPriceMappingByDealerIDMessage: action.payload.message,
                openPortinModal: false,
            };
        case actions.UPDATE_PLAN_PRICE_MAPPING_BY_DEALERID_FAILED:
            return {
                ...state,
                updatePlanPriceMappingByDealerIDLoading: false,
                updatePlanPriceMappingByDealerIDError: action.payload.error,
                updatePlanPriceMappingByDealerIDMessage: null,
                openPortinModal: false,

            };

        case actions.UPDATE_RECHARGE_MAPPING_BY_DEALERID:
            return {
                ...state,
                updateRechargeMappingByDealerIDLoading: true,
                updateRechargeMappingByDealerIDError: null,
                updateRechargeMappingByDealerIDMessage: null,
            };
        case actions.UPDATE_RECHARGE_MAPPING_BY_DEALERID_SUCCESS:
            return {
                ...state,
                updateRechargeMappingByDealerIDLoading: false,
                updateRechargeMappingByDealerIDError: null,
                updateRechargeMappingByDealerIDMessage: action.payload.message,
                openPortinModal: false,
            };
        case actions.UPDATE_RECHARGE_MAPPING_BY_DEALERID_FAILED:
            return {
                ...state,
                updateRechargeMappingByDealerIDLoading: false,
                updateRechargeMappingByDealerIDError: action.payload.error,
                updateRechargeMappingByDealerIDMessage: null,
                openPortinModal: false,

            };

        case actions.UPDATE_DAILY_PLAN_MAPPING_BY_DEALERID:
            return {
                ...state,
                updateDailyPlanMappingByDealerIDLoading: true,
                updateDailyPlanMappingByDealerIDError: null,
                updateDailyPlanMappingByDealerIDMessage: null,
            };
        case actions.UPDATE_DAILY_PLAN_MAPPING_BY_DEALERID_SUCCESS:
            return {
                ...state,
                updateDailyPlanMappingByDealerIDLoading: false,
                updateDailyPlanMappingByDealerIDError: null,
                updateDailyPlanMappingByDealerIDMessage: action.payload.message,
                openPortinModal: false,

            };
        case actions.UPDATE_DAILY_PLAN_MAPPING_BY_DEALERID_FAILED:
            return {
                ...state,
                updateDailyPlanMappingByDealerIDLoading: false,
                updateDailyPlanMappingByDealerIDError: action.payload.error,
                updateDailyPlanMappingByDealerIDMessage: null,
                openPortinModal: false,

            };

        case actions.OPEN_UPDATE_PORTIN_MODAL:
            return {
                ...state,
                openPortinModal: true,
            };

        case actions.CLOSE_UPDATE_PORTIN_MODAL:
            return {
                ...state,
                openPortinModal: false,
            };

        case actions.UPDATE_PORTIN_MAPPING_DATA_BY_DEALERID:
            return {
                ...state,
                updatePortinMappingByDealerIDLoading: true,
                updatePortinMappingByDealerIDError: null,
                updatePortinMappingByDealerIDMessage: null,
            };
        case actions.UPDATE_PORTIN_MAPPING_DATA_BY_DEALERID_SUCCESS:
            return {
                ...state,
                updatePortinMappingByDealerIDLoading: false,
                updatePortinMappingByDealerIDError: null,
                updatePortinMappingByDealerIDMessage: action.payload.message,
                openPortinModal: false,
            };
        case actions.UPDATE_PORTIN_MAPPING_DATA_BY_DEALERID_FAILED:
            return {
                ...state,
                updatePortinMappingByDealerIDLoading: false,
                updatePortinMappingByDealerIDError: action.payload.error,
                updatePortinMappingByDealerIDMessage: null,
                openPortinModal: false,
            };

        case actions.UPDATE_PORTIN_MAPPING_DATA:
            return {
                ...state,
                updatePortinMappingLoading: true,
                updatePortinMappingError: null,
                updatePortinMappingMessage: null,
            };
        case actions.UPDATE_PORTIN_MAPPING_DATA_SUCCESS:
            return {
                ...state,
                updatePortinMappingLoading: false,
                updatePortinMappingError: null,
                updatePortinMappingMessage: action.payload.message,
            };
        case actions.UPDATE_PORTIN_MAPPING_DATA_FAILED:
            return {
                ...state,
                updatePortinMappingLoading: false,
                updatePortinMappingError: action.payload.error,
                updatePortinMappingMessage: null,
            };


        case actions.GET_PORTIN_MAPPING_DATA:
            return {
                ...state,
                portinMappingLoading: true,
                portinMappingError: null,
                portinMappingMessage: null,
                portinMappingData: []
            };
        case actions.GET_PORTIN_MAPPING_DATA_SUCCESS:
            return {
                ...state,
                portinMappingLoading: false,
                portinMappingError: null,
                portinMappingMessage: null,
                portinMappingData: action.payload.data
            };
        case actions.GET_PORTIN_MAPPING_DATA_FAILED:
            return {
                ...state,
                portinMappingLoading: false,
                portinMappingError: action.payload.error,
                portinMappingMessage: null,
                portinMappingData: []
            };

        case actions.UPDATE_DAILY_PLAN_MAPPING_DATA:
            return {
                ...state,
                updateDailyPlanMappingLoading: true,
                updateDailyPlanMappingError: null,
                updateDailyPlanMappingMessage: null,
            };
        case actions.UPDATE_DAILY_PLAN_MAPPING_DATA_SUCCESS:
            return {
                ...state,
                updateDailyPlanMappingLoading: false,
                updateDailyPlanMappingError: null,
                updateDailyPlanMappingMessage: action.payload.message,
            };
        case actions.UPDATE_DAILY_PLAN_MAPPING_DATA_FAILED:
            return {
                ...state,
                updateDailyPlanMappingLoading: false,
                updateDailyPlanMappingError: action.payload.error,
                updateDailyPlanMappingMessage: null,
            };

        case actions.GET_DAILY_PLAN_MAPPING_DATA:
            return {
                ...state,
                dailyPlanMappingLoading: true,
                dailyPlanMappingError: null,
                dailyPlanMappingMessage: null,
                dailyPlanMappingData: []
            };
        case actions.GET_DAILY_PLAN_MAPPING_DATA_SUCCESS:
            return {
                ...state,
                dailyPlanMappingLoading: false,
                dailyPlanMappingError: null,
                dailyPlanMappingMessage: null,
                dailyPlanMappingData: action.payload.data
            };
        case actions.GET_DAILY_PLAN_MAPPING_DATA_FAILED:
            return {
                ...state,
                dailyPlanMappingLoading: false,
                dailyPlanMappingError: action.payload.error,
                dailyPlanMappingMessage: null,
                dailyPlanMappingData: []
            };

        case actions.UPDATE_PLAN_CHILD_PRICE_MAPPING_DATA:
            return {
                ...state,
                loading: true,
                buttonLoading: true,
                planChildPriceMappingError: null,
                planChildPriceMappingSuccess: null,
            };
        case actions.UPDATE_PLAN_CHILD_PRICE_MAPPING_DATA_SUCCESS:
            return {
                ...state,
                loading: false,
                buttonLoading: false,
                planChildPriceMappingError: null,
                planChildPriceMappingSuccess: action.message,
                PlanPriceMappingData: action.data,
            };
        case actions.UPDATE_PLAN_CHILD_PRICE_MAPPING_DATA_FAILED:
            return {
                ...state,
                loading: false,
                buttonLoading: false,
                planChildPriceMappingError: action.serror,
                planChildPriceMappingSuccess: null,
            };

        case actions.CHECK_RECHARGE_MAPPING_EXISTS:
            return {
                ...state,
                checkRechargeMappingExistsLoading: true,
                checkRechargeMappingExistsError: null,
                checkRechargeMappingExistsMessage: null,
            };
        case actions.CHECK_RECHARGE_MAPPING_EXISTS_SUCCESS:
            return {
                ...state,
                checkRechargeMappingExistsLoading: false,
                checkRechargeMappingExistsError: null,
                checkRechargeMappingExistsMessage: action.payload.message,
            };
        case actions.CHECK_RECHARGE_MAPPING_EXISTS_FAILED:
            return {
                ...state,
                checkRechargeMappingExistsLoading: false,
                checkRechargeMappingExistsError: action.payload.error,
                checkRechargeMappingExistsMessage: null,
            };

        case actions.UPDATE_RECHARGE_MAPPING_DATA:
            return {
                ...state,
                updateRechargeMappingLoading: true,
                updateRechargeMappingError: null,
                updateRechargeMappingMessage: null,
            };
        case actions.UPDATE_RECHARGE_MAPPING_DATA_SUCCESS:
            return {
                ...state,
                updateRechargeMappingLoading: false,
                updateRechargeMappingError: null,
                updateRechargeMappingMessage: action.payload.message,
            };
        case actions.UPDATE_RECHARGE_MAPPING_DATA_FAILED:
            return {
                ...state,
                updateRechargeMappingLoading: false,
                updateRechargeMappingError: action.payload.error,
                updateRechargeMappingMessage: null,
            };

        case actions.GET_RECHARGE_MAPPING_DATA:
            return {
                ...state,
                rechargeMappingLoading: true,
                rechargeMappingError: null,
                rechargeMappingMessage: null,
                rechargeMappingData: []
            };
        case actions.GET_RECHARGE_MAPPING_DATA_SUCCESS:
            return {
                ...state,
                rechargeMappingLoading: false,
                rechargeMappingError: null,
                rechargeMappingMessage: null,
                rechargeMappingData: action.payload.data
            };
        case actions.GET_RECHARGE_MAPPING_DATA_FAILED:
            return {
                ...state,
                rechargeMappingLoading: false,
                rechargeMappingError: action.payload.error,
                rechargeMappingMessage: null,
                rechargeMappingData: []
            };

        case actions.GET_PLAN_WISE_MAPPING:
            return {
                ...state,
                planWiseMappingLoading: true,
                planWiseMappingError: null,
                planWiseMappingMessage: null,
            };

        case actions.GET_PLAN_WISE_MAPPING_SUCCESS:
            return {
                ...state,
                planWiseMappingLoading: false,
                planWiseMappingError: null,
                planWiseMappingMessage: null,
                planWiseMappingList: action.payload.data,
            };

        case actions.GET_PLAN_WISE_MAPPING_FAILED:
            return {
                ...state,
                planWiseMappingLoading: false,
                planWiseMappingError: action.payload.error,
                planWiseMappingMessage: null,
            };

        case actions.GET_ALL_PLAN_PRICE_MAPPING_DATA:
            return {
                ...state,
                loading: true,
                planPriceMappingError: null,
                planPriceMappingSuccess: null,
            };

        case actions.GET_ALL_PLAN_PRICE_MAPPING_DATA_SUCCESS:
            return {
                ...state,
                loading: false,
                planPriceMappingError: null,
                planPriceMappingSuccess: null,
                PlanPriceMappingData: action.payload.data,
            };

        case actions.GET_ALL_PLAN_PRICE_MAPPING_DATA_FAILED:
            return {
                ...state,
                loading: false,
                planPriceMappingError: action.payload.error,
                planPriceMappingSuccess: null,
            };

        case actions.UPDATE_PLAN_PRICE_MAPPING_DATA:
            return {
                ...state,
                loading: true,
                buttonLoading: true,
                planPriceMappingError: null,
                planPriceMappingSuccess: null,
            };

        case actions.UPDATE_PLAN_PRICE_MAPPING_DATA_SUCCESS:
            return {
                ...state,
                loading: false,
                buttonLoading: false,
                planPriceMappingError: null,
                planPriceMappingSuccess: action.message,
                PlanPriceMappingData: action.data,
            };

        case actions.UPDATE_PLAN_PRICE_MAPPING_DATA_FAILED:
            return {
                ...state,
                loading: false,
                buttonLoading: false,
                planPriceMappingError: action.serror,
                planPriceMappingSuccess: null,
            };
        case actions.RESET_PLAN_PRICE_MAPPING_MESSAGES:
            return {
                ...state,
                loading: false,
                buttonLoading: false,
                planPriceMappingError: null,
                planPriceMappingSuccess: null,
                updatePortinMappingError: null,
                updatePortinMappingMessage: null,
                updatePortinMappingByDealerIDMessage: null,
                updatePortinMappingByDealerIDError: null,
                updateDailyPlanMappingByDealerIDError: null,
                updateDailyPlanMappingByDealerIDMessage: null,
                updateRechargeMappingByDealerIDError: null,
                updateRechargeMappingByDealerIDMessage: null,
                updatePlanPriceMappingByDealerIDError: null,
                updatePlanPriceMappingByDealerIDMessage: null,
                updateChildPriceMappingByDealerIDError: null,
                updateChildPriceMappingByDealerIDMessage: null,
                updateDailyPlanMappingError: null,
                updateDailyPlanMappingMessage: null,
            };
        default:
            return state;
    }
}